export default function InboundReferralsIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13 0C13.5523 0 14 0.44772 14 1V8C14 8.5523 13.5523 9 13 9C12.4477 9 12 8.5523 12 8V1C12 0.44772 12.4477 0 13 0ZM6 5.75H1.25C0.559644 5.75 0 5.19036 0 4.5C0 3.80965 0.559644 3.25 1.25 3.25H6V1.20711C6 0.76165 6.53857 0.53857 6.85355 0.85355L10.1464 4.14645C10.3417 4.34171 10.3417 4.65829 10.1464 4.85355L6.85355 8.1464C6.53857 8.4614 6 8.2383 6 7.7929V5.75Z'
      />
    </svg>
  );
}
